const mapOrder = (a: Array<any>, order: Array<any>, key: string) => {
  const map = order.reduce((r, v, i) => ((r[v] = i), r), {})
  return a.sort((a, b) => map[a[key]] - map[b[key]])
}

export default mapOrder
